import React, { PureComponent } from 'react';
import mapInterface from '../../../mapboxgl/mapInterface';
import MarkerPopup from '../MarkerPopup';
import './Marker.scss';

class Marker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      onMap: false,
      balloonCreated: false,
      highlighted: false,
      balloonOpened: false,
      draggable: false,
      order: null,
    };
  }
  componentDidMount() {
    const {
      data,
      draggable,
      className,
      onDragStart,
      onDragEnd,
    } = this.props;

    this.showMarkerOnMap(data, className, draggable);
    if (draggable) {
      this.setState({ draggable }, () =>
        this.makeDraggable(onDragStart, onDragEnd)
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      data,
      highlight,
      data: { lat, lng, callback, order, panoId },
      showPopup,
      className,
    } = this.props;

    if (prevProps.data.lat !== lat || prevProps.data.lng !== lng) {
      this.updateMarkerPosition(lat, lng);
    }

    if (!callback) {
      mapInterface.updateMarkerNumber(this.markerElement, order);
    }

    const redrawMarker = panoId !== prevProps.data.panoId
      || highlight !== prevProps.highlight
      || (showPopup && prevProps.showPopup !== showPopup);

    if (this.markerElement && redrawMarker) {
      this.markerElement.remove();
      this.showMarkerOnMap(data, className, false);
    }

    this.toggleActiveMarker();
  }

  componentWillUnmount() {
    this.hideMarkerOnMap();
  }

  showMarkerOnMap = (data, className, draggable) => {
    const { tourId, switchView, changeStop, highlight, showPopup } = this.props;
    const { lat, lng, order, callback, panoId, name, tourName } = data;

    if (showPopup) {
      this.markerElement = mapInterface.createMarkerWithPopup(
        {
          markerCoords: [lng, lat],
          className,
          order,
          draggable,
          stopName: name,
          changeStop,
          highlighted: highlight,
        },
        <MarkerPopup
          {...data}
          switchView={switchView}
          changeStop={changeStop}
          order={order}
          tourId={tourId}
        />,
        callback
      );
    } else {
      this.markerElement = mapInterface.createMarker(
        {
          markerCoords: [lng, lat],
          className,
          order,
          panoId,
          stopName: name,
          changeStop,
          draggable,
          tourName,
          highlighted: highlight
        },
        callback
      );
    }
    this.setState({ onMap: true, order });
  };

  showRadarMarker = (radarPos, northPos) => {
    mapInterface.updateMarkerImage(this.markerElement, radarPos, northPos);
  };

  hideMarkerOnMap() {
    if (this.markerElement) {
      mapInterface.deleteMarker(this.markerElement);
    }
  }

  updateMarkerPosition(lat, lng) {
    mapInterface.setMarkerLocation(this.markerElement, lat, lng);
  }

  makeDraggable(onDragStart, onDragEnd) {
    mapInterface.makeMarkerDraggable(
      this.markerElement,
      onDragStart,
      onDragEnd
    );
    this.setState({ draggable: true });
  }

  makeStationary() {
    mapInterface.disableMarkerDragging(this.markerElement);
    this.setState({ draggable: false });
  }

  toggleActiveMarker() {
    const { highlight } = this.props;

    if (this.markerElement?._element.classList.contains('enlarge') && !highlight) {
      this.markerElement._element.classList.remove('enlarge');
    } else if (highlight) {
      this.markerElement?._element.classList.add('enlarge');
    }
  }

  render() {
    return null;
  }
}

export default Marker;
